import React, { Component } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { injectIntl, FormattedMessage } from 'react-intl';

import HUBContext from '../services/HUBContext';

const styles = theme => ({
    alert: {
        color: '#721c24',
        backgroundColor: '#f8d7da',
        padding: '.75rem 1.25rem',
        marginBottom: '1rem',
        border: '1px solid #f5c6cb',
        borderRadius: '.25rem'
    }
});

export class NotSuccess extends Component {

    render() {
        const { classes } = this.props;

        return (<Grid container className={ classes.alert }>
                    <Grid item xs={12} sm={12} lg={12} xl={12}>
                        <FormattedMessage id='notSuccess' defaultMessage='It was not possible to complete the operation, try again' />
                    </Grid>
                </Grid>);
    }

}

NotSuccess.contextType = HUBContext;

export default withStyles(styles)(injectIntl(NotSuccess));